export const truncate = (string: string, breakpoint: number) =>
  string.length < breakpoint ? string : `${string.substring(0, breakpoint - 3)}...`;
